import React from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { longwork } from "./constdata";

const Longwork = ({ data, skillname, onSave }) => {
  const onSelect = (value) => {
    onSave("longwork", value);
  };

  return (
    <>
      <section className="longWorkSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>4. How Long Do You Need Help?</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormControl component="fieldset" className="expRadio">
                <RadioGroup
                  aria-label="experience"
                  defaultValue="less_1_month"
                  name="radio-buttons-group"
                  onChange={(e) => onSelect(e.target.value)}
                  value={data}
                >
                  {longwork.map((_l) => (
                    <FormControlLabel
                      value={_l.value}
                      className="radioLabel"
                      control={<Radio />}
                      label={_l.label}
                      key={_l.value}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </div>

            <div
              className={
                data === "other" ? "col-md-12 d-block" : "col-md-12 d-none"
              }
            >
              <div className="col-md-12 skillForm pl-md-0">
                <form className="form-inline d-block d-sm-flex">
                  <div className="form-group mb-0">
                    <input
                      type="text"
                      className="form-control"
                      name="skillname"
                      placeholder="Enter the your text"
                      value={skillname}
                      onChange={(e) => onSave("skillname", e.target.value)}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Longwork;
